import { roles } from "@Modules/Roles/configs/constants";

import list_roles from "./reducers";

export default {
  [roles]: list_roles,
};
